import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'sports_outdoor_hard_goods'

export const dataPointDefinition = {
  retracedId: 'sports_outdoor_hard_goods',
  name: 'Sports & Outdoor - Hard goods',
  description:
    'This includes, e.g., snow sports equipment, bicycles & scooters, water sports equipment, fitness & gym equipment, camping chairs, camping cookware, helmets, goggles, rackets & bats, balls, leather sports equipment.',
  meta: {
    slcpMeta: {
      key: 'fp-pi-1-6',
      number: 'FP-PRO-1-8',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'fp-pro-1',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'Facility Profile',
      verificationSelectionOptList: 'verf-f-list',
      nonComOptionList: '',
      nonCompliance: '',
      humanShowHide: '[1]',
      machineShowHide: '[1]',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'fp-pi-1-6', version: '1.7.0', provider: 'slcp'}],
  sortingId: 27980,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
